var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpeningHours(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9 15.1V10.6C16.9 10.3613 16.8052 10.1324 16.6364 9.9636C16.4676 9.79482 16.2387 9.7 16 9.7C15.7613 9.7 15.5324 9.79482 15.3636 9.9636C15.1948 10.1324 15.1 10.3613 15.1 10.6V16C15.1 16.2387 15.1948 16.4676 15.3636 16.6364C15.5324 16.8052 15.7613 16.9 16 16.9H20.5C20.7387 16.9 20.9676 16.8052 21.1364 16.6364C21.3052 16.4676 21.4 16.2387 21.4 16C21.4 15.7613 21.3052 15.5324 21.1364 15.3636C20.9676 15.1948 20.7387 15.1 20.5 15.1H16.9ZM16 25C11.0293 25 7 20.9707 7 16C7 11.0293 11.0293 7 16 7C20.9707 7 25 11.0293 25 16C25 20.9707 20.9707 25 16 25Z",
    fill: "#6F7F97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpeningHours);
export default __webpack_public_path__ + "static/media/openingHours.243269674b82346d05a4bfbb7e54d712.svg";
export { ForwardRef as ReactComponent };